import React from 'react';
import { Link } from 'react-router-dom';
import SearchForm from '../SearchForm';

function NavBar() {
  return (
    <div
      className="flex items-center 
    justify-between p-4 border-b fixed w-full bg-white space-x-1"
    >
      <Link to="/">
        <div className="flex space-x-2 items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7 md:h-8 md:w-8 text-red-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z"
              clipRule="evenodd"
            />
          </svg>
          <p className="text-xl md:text-2xl font-bold tracking-wider">
            VIDTUBE
          </p>
        </div>
      </Link>
      <SearchForm />
    </div>
  );
}

export default NavBar;
